import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: "S'AGIT-IL D'UN PRODUIT PHYSIQUE OU NUMÉRIQUE ?",
  answer: 'Football Prêt : Système 365 est un produit 100% numérique, livré instantanément au format PDF. Vous pouvez y accéder depuis votre ordinateur, votre tablette ou votre smartphone.'
}, {
  question: "AI-JE BESOIN D'EXPÉRIENCE EN COACHING POUR L'UTILISER ?",
  answer: "Non.\n\nLe système est conçu pour être utilisé directement, avec des instructions claires à chaque étape — que vous débutiez ou que vous soyez un entraîneur de football expérimenté."
}, {
  question: 'PUIS-JE IMPRIMER LES DOCUMENTS ?',
  answer: 'Oui.\n\nTous les documents sont conçus pour être imprimés facilement et utilisés directement sur le terrain de football pendant vos séances.'
}, {
  question: 'LES BONUS SONT-ILS INCLUS ?',
  answer: 'Oui.\n\nLes 5 bonus sont inclus gratuitement avec votre achat, sans frais supplémentaire.'
}, {
  question: 'DANS QUELLE DEVISE VAIS-JE ÊTRE FACTURÉ ?',
  answer: 'Le paiement est automatiquement converti et affiché dans votre devise locale au moment de passer commande.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-navy-950 border-t border-navy-800" data-id="element-42" data-mp="1fqgm9if5w653">
      <div className="container mx-auto px-4" data-id="element-43" data-mp="11vnv1mpwt1io">
        <div className="text-center mb-16" data-id="element-44" data-mp="16np8vd2q70at">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-45" data-mp="16pif4r9ffiia">
QUESTIONS FRÉQUENTES
          </motion.h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-46" data-mp="n22kqsov6ros">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-900 border border-navy-800 rounded-xl overflow-hidden" data-id="element-47" data-mp="2pnya60to3btd" data-mpi={index}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500" data-id="element-48" data-mp="33n7lam30nfqh">
                <span className="font-oswald text-xl text-white uppercase tracking-wide pr-8" data-id="element-49" data-mp="1n8xyvxic412a">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-gold-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-50" data-mp="3utwr0jfnafbo" />
              </button>

              <AnimatePresence data-id="element-51" data-mp="7ooy0nmfy6b0">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-52" data-mp="7ndxqxs7fgon">
                    <div className="px-6 pb-6 text-gray-400 whitespace-pre-line" data-id="element-53" data-mp="2s731hzlma7q3">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}